import gql from "graphql-tag"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

// only returning uuid to reduce load, do not add more fields here, instead use CreateUser service
const query = gql`
  mutation CreateUserForBulk($user: NewUserInput!) {
    createUser(user: $user) {
      uuid
    }
  }
`

export const createUserForBulkKey = getQueryNames(query)[0]

export default query
